import { cn } from "@/lib/utils";
import React from "react";
import { useState } from "react";
import { SquareDashedIcon } from "../icons";

interface EmptyInputStateProps {
  label?: string;
  onClick: () => void;
}

const EmptyInputState: React.FC<EmptyInputStateProps> = ({
  label = "Add fill",
  onClick,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={cn(
        "group w-full flex items-center justify-start h-7 bg-secondary-n-950 rounded-md text-secondary-800 border border-transparent hover:border-secondary-n-600 cursor-pointer",
        hovered
          ? "text-secondary-900 border-secondary-600"
          : "text-secondary-800",
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <div className="p-1 flex flex-row items-center justify-start gap-x-2">
        <div className="py-1 pl-1.5">
          <SquareDashedIcon
            strokeWidth={1}
            className="text-secondary-n-600 w-4 h-4"
          />
        </div>
        <div className="text-xs text-secondary-n-600">{label}</div>
      </div>
    </div>
  );
};

export default React.memo(EmptyInputState);
